import moment from 'moment';
import React, { useEffect } from 'react';
import LaddaButton, { SLIDE_DOWN } from 'react-ladda';
import { connect, useDispatch } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import {
  emailField,
  numericFieldWhereNotStartWithZero,
  phoneField,
  requiredField,
} from '../../helpers/validator';
import Input from '../common/input';
/*import Textarea from '../common/textarea';*/

let DynamicEventServiceDetailsForm = (props) => {
  const { handleSubmit, isLoading, errorMessage, slots, serviceSlot } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    console.log('Fetched language from browser (i18n.resolvedlanguage):', i18n.resolvedLanguage);
  }, [i18n.resolvedLanguage]);

  const onSlotChange = (newSlot) => {
    dispatch(change('event-service-details', 'event_slot_id', newSlot.id));
  };

  const setStatusId = (statusId) => {
    dispatch(change('event-service-details', 'status_id', statusId));
  };

  const noSlots = slots.filter((s) => s.available).length === 0;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        type="text"
        name="first_name"
        label={t('name')}
        className="form-control"
        placeholder={t('enter_first_name', 'Enter your first name')}
        component={Input}
      />
      <Field
        type="text"
        name="last_name"
        label={t('lastName')}
        className="form-control"
        placeholder={t('enter_last_name', 'Enter your last name')}
        component={Input}
      />
      <Field
        type="text"
        name="given_company"
        label={t('company')}
        className="form-control"
        placeholder={t('enter_company', 'Enter the company you work for')}
        component={Input}
      />
      <Field
        type="text"
        name="given_email"
        label={t('email')}
        className="form-control"
        placeholder={t('enter_email', 'Enter your email')}
        component={Input}
      />
      {/*
      <hr className="line" />
      <Field
        name="comments_to_mechanic"
        label="Comments to the mechanic"
        className="form-control"
        placeholder="Add comment (optional)"
        component={Textarea}
      />
      */}
      <hr className="line" />
      <Field
        type="tel"
        name="phone_number"
        label={
          <>
            {t('phoneNumber')}
            <br />
            <span className="format-label">
              ({t('phoneFormat', 'without 0 at the start and without spaces')})
            </span>
          </>
        }
        countryCode="+46"
        className="form-control"
        placeholder={t('phonePlaceholder', 'Mobile number')}
        component={Input}
      />
      <hr className="line" />
      <Field
        name="event_slot_id"
        component={(fieldProps) => (
          <SlotList
            slots={slots}
            onSlotChange={onSlotChange}
            selectedSlot={fieldProps.input.value}
            error={fieldProps.meta.error}
            serviceSlot={serviceSlot}
          />
        )}
      />

      {!noSlots && (
        <LaddaButton
          className="btn w-100 submit-button"
          disabled={isLoading}
          data-style={SLIDE_DOWN}
          onClick={() => {
            setStatusId(1);
          }}
        >
          {t('book')}
        </LaddaButton>
      )}

      {noSlots && props.eventStatus === 2 && (
        <>
          <div className="text-center" style={{ paddingTop: 20, paddingBottom: 20 }}>
            <p className="mb-1" style={{ fontWeight: 'bold' }}>
              {t('noAvailableSlotsTitle', 'No available time slots?')}
            </p>
            <p className="mb-1">
              {t(
                'waitlistMessage',
                'Put yourself on the waiting list and we will book you in if a time becomes available.'
              )}
            </p>
          </div>

          <LaddaButton
            className="btn w-100 waitlist-button"
            disabled={isLoading}
            data-style={SLIDE_DOWN}
            onClick={() => {
              setStatusId(5);
            }}
          >
            {t('waitlist')}
          </LaddaButton>
        </>
      )}
      <p className="text-danger text-center" style={{ marginTop: 10 }}>
        {errorMessage}
      </p>
    </form>
  );
};

function SlotList({ slots, onSlotChange, selectedSlot, error, serviceSlot }) {
  const { t } = useTranslation();
  if (!slots || slots.length === 0) {
    return <p className="text-center">{t('noAvailableSlots', 'No available time slots')}</p>;
  }

  return (
    <div style={error ? { border: '1px red' } : {}}>
      <label className="input-label">{t('dateAndTime', 'Date and check-in time')}</label>
      {slots.map((slot) => (
        <EventSlot
          key={slot.id}
          slot={slot}
          onChange={onSlotChange}
          isSelected={slot.id === selectedSlot}
          timeLabel={serviceSlot?.name}
        />
      ))}
    </div>
  );
}

function EventSlot({ slot, onChange, isSelected, timeLabel }) {
  const { t, i18n } = useTranslation();
  moment.locale(i18n.resolvedLanguage);
  const startTime = moment(slot.start_time);
  const endTime = moment(slot.end_time);

  const formattedDate1 = startTime.format('dddd ');
  const formattedDate2 = startTime.format('(DD/MM)');
  const formattedTime = timeLabel || `${startTime.format('HH:mm')} - ${endTime.format('HH:mm')}`;

  const canBeSelected = slot.available_services > 0 && slot.available;

  return (
    <div
      className={`event-slot ${canBeSelected ? '' : 'event-slot-disabled'}`}
      style={{ display: 'flex', flexDirection: 'row' }}
      onClick={canBeSelected ? () => onChange(slot) : undefined}
    >
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center' }}>
        <p style={{ margin: 0, fontWeight: 'lighter' }}>
          <span style={{ fontWeight: 'bold' }}>{formattedDate1}</span>
          {formattedDate2} <span style={{ fontWeight: 'bold' }}>{formattedTime}</span>
        </p>
        <p style={{ margin: 0, fontWeight: 'lighter' }}>
          {slot.available_services > 0
            ? `${slot.available_services} ${t('slotsLeft', 'slots left')}`
            : t('fullyBooked', 'Fully booked.')}
        </p>
      </div>
      {canBeSelected ? (
        <div className={'radio-button'}>
          {isSelected && <div className="radio-button-selected" />}
        </div>
      ) : (
        <div style={{ width: '30px' }} />
      )}
    </div>
  );
}

const eventServiceDetailsFormValidator = (values) => {
  const errors = {};
  requiredField(values, errors, 'first_name', 'VALIDATION.FIRST-NAME.ERROR_REQUIRED');
  requiredField(values, errors, 'last_name', 'VALIDATION.LAST-NAME.ERROR_REQUIRED');
  requiredField(values, errors, 'given_email', 'VALIDATION.EMAIL.ERROR_REQUIRED');
  requiredField(values, errors, 'phone_number', 'VALIDATION.TOS.ERROR_REQUIRED');
  requiredField(values, errors, 'given_company', 'VALIDATION.COMPANY.ERROR_REQUIRED');
  if (values.status_id === 1) {
    requiredField(values, errors, 'event_slot_id', 'VALIDATION.EVENT-SLOT.ERROR_REQUIRED');
  }
  emailField(values, errors, 'given_email', 'VALIDATION.EMAIL.WRONG_FORMAT');
  numericFieldWhereNotStartWithZero(
    values,
    errors,
    'phone_number',
    'VALIDATION.TOS.WRONG_NUMERIC_FORMAT'
  );
  phoneField(values, errors, 'phone_number', 'VALIDATION.TOS.WRONG_FORMAT');

  return errors;
};

DynamicEventServiceDetailsForm = reduxForm({
  form: 'event-service-details',
  validate: eventServiceDetailsFormValidator,
})(DynamicEventServiceDetailsForm);

DynamicEventServiceDetailsForm = connect((state) => {
  const slots = state.service.slots || [];
  const selectableSlots = slots.filter((slot) => slot.available_services > 0 && slot.available);
  const firstSlotId = selectableSlots.length > 0 ? selectableSlots[0].id : null;
  return {
    initialValues: {
      ...state.service.user,
      place: state.service.event?.place,
      event_slot_id: firstSlotId,
    },
    enableReinitialize: true,
  };
})(DynamicEventServiceDetailsForm);

export default DynamicEventServiceDetailsForm;
